/**
 * Umbrales de calidad alineados a Azure Document Intelligence
 * y a la política de Micromarket para registro de facturas IA.
 *
 * Azure (límites duros): dimensiones entre 50x50 y 10000x10000 px.
 * Operativo: lado menor >= 1000 (bloqueo), >= 1500 (recomendado ~150-300 DPI).
 * Brillo: advertir fuera de 30-220.
 * App: máx. 10 fotos y 10 MB.
 */
export const UMBRALES_CALIDAD_IMAGEN_FACTURA_IA = Object.freeze({
  dimensionMinimaAzure: 50,
  dimensionMaximaAzure: 10000,
  ladoMenorMinimo: 1000,
  ladoMenorRecomendado: 1500,
  brilloMinimo: 30,
  brilloMaximo: 220,
  tamanoMaximoBytes: 10485760,
  paginasMaximas: 10
});
